import React from "react";
import { activeDialogState } from "../../redux/slices/dialogsSlice";
import { useSelector } from "react-redux";
import { ReduxUpdater } from "../../redux/ReduxUpdater";
import { ReceiptUpload } from "../components/elements/ReceiptUpload";

const UploadReceiptDialog = () => {
    const currentActiveDialogState = useSelector(activeDialogState);
    
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                ReduxUpdater.currentDialog = null;
            }
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    React.useEffect(() => {
        setOpen(currentActiveDialogState === 'uploadReceipt');
    }, [currentActiveDialogState]);

    return (
        <div>
            {/* Overlay */}
            {open && (
                <div className="hs-overlay fixed inset-0 z-[60] overflow-y-auto bg-gray-900/50 p-4">
                    <div className="w-[1262px] max-w-[100vw] h-[-webkit-fill-available] flex justify-center items-center overflow-hidden">
                        <ReceiptUpload />
                    </div>
                </div>
            )}
        </div>
    );
}

export default UploadReceiptDialog;
